import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { User, Bell, Shield, Database, Zap } from 'lucide-react';
export function SettingsPage() {
  const [activeTab, setActiveTab] = useState<'profile' | 'notifications' | 'security' | 'data' | 'automations'>('profile');
  const tabs = [{
    key: 'profile',
    label: 'Profil',
    icon: User
  }, {
    key: 'notifications',
    label: 'Benachrichtigungen',
    icon: Bell
  }, {
    key: 'security',
    label: 'Sicherheit',
    icon: Shield
  }, {
    key: 'data',
    label: 'Daten & Export',
    icon: Database
  }, {
    key: 'automations',
    label: 'Automationen',
    icon: Zap
  }];
  return <div className="p-6 space-y-6" data-id="element-464">
      <div data-id="element-465">
        <h1 className="text-3xl font-bold text-foreground" data-id="element-466">Einstellungen</h1>
        <p className="text-muted-foreground mt-1" data-id="element-467">
          Systemeinstellungen und Präferenzen verwalten
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-468">
        <div className="space-y-2" data-id="element-469">
          {tabs.map(tab => {
          const Icon = tab.icon;
          return <button key={tab.key} onClick={() => setActiveTab(tab.key as any)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors ${activeTab === tab.key ? 'bg-[#fef5ee] text-foreground border border-[#eb6641]/30' : 'text-muted-foreground hover:bg-muted'}`} data-id="element-470">
                <Icon className="h-5 w-5" data-id="element-471" />
                <span className="font-medium" data-id="element-472">{tab.label}</span>
              </button>;
        })}
        </div>

        <div className="lg:col-span-3" data-id="element-473">
          {activeTab === 'profile' && <Card data-id="element-474">
              <CardHeader data-id="element-475">
                <CardTitle data-id="element-476">Profil-Einstellungen</CardTitle>
                <CardDescription data-id="element-477">
                  Verwalten Sie Ihre persönlichen Informationen
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-478">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-479">
                  <div className="space-y-2" data-id="element-480">
                    <Label data-id="element-481">Vorname</Label>
                    <Input placeholder="Dennis" defaultValue="Dennis" data-id="element-482" />
                  </div>
                  <div className="space-y-2" data-id="element-483">
                    <Label data-id="element-484">Nachname</Label>
                    <Input placeholder="Jedlicka" defaultValue="Jedlicka" data-id="element-485" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-486">
                  <Label data-id="element-487">E-Mail</Label>
                  <Input type="email" placeholder="dennis@example.com" defaultValue="dennis@example.com" data-id="element-488" />
                </div>
                <div className="space-y-2" data-id="element-489">
                  <Label data-id="element-490">Telefon</Label>
                  <Input type="tel" placeholder="+49 123 456789" data-id="element-491" />
                </div>
                <div className="space-y-2" data-id="element-492">
                  <Label data-id="element-493">Unternehmen</Label>
                  <Input placeholder="DJ Consulting" data-id="element-494" />
                </div>
                <Button variant="secondary" data-id="element-495">Änderungen speichern</Button>
              </CardContent>
            </Card>}

          {activeTab === 'notifications' && <Card data-id="element-496">
              <CardHeader data-id="element-497">
                <CardTitle data-id="element-498">Benachrichtigungen</CardTitle>
                <CardDescription data-id="element-499">
                  Verwalten Sie Ihre Benachrichtigungseinstellungen
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-500">
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-501">
                  <div data-id="element-502">
                    <p className="font-medium text-foreground" data-id="element-503">
                      Browser Benachrichtigungen
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-504">
                      Erhalten Sie Updates im Browser
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-505" />
                </div>
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-506">
                  <div data-id="element-507">
                    <p className="font-medium text-foreground" data-id="element-508">
                      Follow-up Erinnerungen
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-509">
                      Tägliche Erinnerungen für Follow-ups
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-510" />
                </div>
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-511">
                  <div data-id="element-512">
                    <p className="font-medium text-foreground" data-id="element-513">
                      Überfällige Aufgaben
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-514">
                      Benachrichtigung bei überfälligen Tasks
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-515" />
                </div>
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-516">
                  <div data-id="element-517">
                    <p className="font-medium text-foreground" data-id="element-518">Neue Kontakte</p>
                    <p className="text-sm text-muted-foreground" data-id="element-519">
                      Info bei neuen Kontakten
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" data-id="element-520" />
                </div>
                <Button variant="secondary" data-id="element-521">Einstellungen speichern</Button>
              </CardContent>
            </Card>}

          {activeTab === 'security' && <Card data-id="element-522">
              <CardHeader data-id="element-523">
                <CardTitle data-id="element-524">Sicherheit</CardTitle>
                <CardDescription data-id="element-525">
                  Verwalten Sie Ihre Sicherheitseinstellungen
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-526">
                <div className="space-y-2" data-id="element-527">
                  <Label data-id="element-528">Aktuelles Passwort</Label>
                  <Input type="password" placeholder="••••••••" data-id="element-529" />
                </div>
                <div className="space-y-2" data-id="element-530">
                  <Label data-id="element-531">Neues Passwort</Label>
                  <Input type="password" placeholder="••••••••" data-id="element-532" />
                </div>
                <div className="space-y-2" data-id="element-533">
                  <Label data-id="element-534">Passwort bestätigen</Label>
                  <Input type="password" placeholder="••••••••" data-id="element-535" />
                </div>
                <Button variant="secondary" data-id="element-536">Passwort ändern</Button>

                <div className="pt-6 border-t border-border" data-id="element-537">
                  <h3 className="font-medium text-foreground mb-4" data-id="element-538">
                    Zwei-Faktor-Authentifizierung
                  </h3>
                  <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-539">
                    <div data-id="element-540">
                      <p className="font-medium text-foreground" data-id="element-541">
                        2FA aktivieren
                      </p>
                      <p className="text-sm text-muted-foreground" data-id="element-542">
                        Zusätzliche Sicherheitsebene
                      </p>
                    </div>
                    <Button variant="outline" size="sm" data-id="element-543">
                      Aktivieren
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>}

          {activeTab === 'data' && <Card data-id="element-544">
              <CardHeader data-id="element-545">
                <CardTitle data-id="element-546">Daten & Export</CardTitle>
                <CardDescription data-id="element-547">
                  Verwalten und exportieren Sie Ihre Daten
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-548">
                <div className="p-4 border border-border rounded-lg" data-id="element-549">
                  <h3 className="font-medium text-foreground mb-2" data-id="element-550">
                    Kontakte exportieren
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-551">
                    Exportieren Sie alle Ihre Kontakte als CSV
                  </p>
                  <Button variant="outline" data-id="element-552">CSV Export</Button>
                </div>
                <div className="p-4 border border-border rounded-lg" data-id="element-553">
                  <h3 className="font-medium text-foreground mb-2" data-id="element-554">
                    KPI Daten exportieren
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-555">
                    Exportieren Sie Ihre KPI-Daten
                  </p>
                  <Button variant="outline" data-id="element-556">Daten exportieren</Button>
                </div>
                <div className="p-4 border border-border rounded-lg" data-id="element-557">
                  <h3 className="font-medium text-foreground mb-2" data-id="element-558">
                    LinkedIn Routine Statistiken
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-559">
                    Exportieren Sie Ihre Routine-Statistiken
                  </p>
                  <Button variant="outline" data-id="element-560">Statistiken exportieren</Button>
                </div>
                <div className="p-4 border border-red-500/20 rounded-lg bg-red-500/5" data-id="element-561">
                  <h3 className="font-medium text-red-600 mb-2" data-id="element-562">
                    Daten löschen
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-563">
                    Alle Ihre Daten permanent löschen
                  </p>
                  <Button variant="destructive" data-id="element-564">Alle Daten löschen</Button>
                </div>
              </CardContent>
            </Card>}

          {activeTab === 'automations' && <Card data-id="element-565">
              <CardHeader data-id="element-566">
                <CardTitle data-id="element-567">Automationen</CardTitle>
                <CardDescription data-id="element-568">
                  Automatisieren Sie Workflows innerhalb von DJ CRM
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-569">
                <div className="p-4 rounded-lg bg-[#fef5ee] border border-[#eb6641]/20 mb-4" data-id="element-570">
                  <p className="text-sm text-muted-foreground" data-id="element-571">
                    <strong data-id="element-572">Hinweis:</strong> Diese Automationen funktionieren
                    nur innerhalb von DJ CRM und beeinflussen keine externen
                    Systeme.
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-573">
                  <div className="flex items-center justify-between mb-2" data-id="element-574">
                    <h3 className="font-medium text-foreground" data-id="element-575">
                      Auto Follow-up nach 3 Tagen
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-576" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-577">
                    Kontakt wird automatisch in "Follow-up" verschoben, wenn 3
                    Tage keine Aktivität
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-578">
                  <div className="flex items-center justify-between mb-2" data-id="element-579">
                    <h3 className="font-medium text-foreground" data-id="element-580">
                      Überfällige Aufgaben markieren
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-581" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-582">
                    Kontakte mit überschrittenem Follow-up Datum werden
                    automatisch als "Überfällig" markiert
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-583">
                  <div className="flex items-center justify-between mb-2" data-id="element-584">
                    <h3 className="font-medium text-foreground" data-id="element-585">
                      LinkedIn Routine Streak-Tracking
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-586" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-587">
                    Automatische Berechnung und Anzeige Ihres täglichen Streaks
                    in der Routine
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-588">
                  <div className="flex items-center justify-between mb-2" data-id="element-589">
                    <h3 className="font-medium text-foreground" data-id="element-590">
                      Auto-Tagging nach Stage
                    </h3>
                    <input type="checkbox" className="h-5 w-5" data-id="element-591" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-592">
                    Kontakte erhalten automatisch Tags basierend auf ihrer
                    Pipeline-Stage
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-593">
                  <div className="flex items-center justify-between mb-2" data-id="element-594">
                    <h3 className="font-medium text-foreground" data-id="element-595">
                      Kalender-Synchronisation
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-596" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-597">
                    Follow-up Termine werden automatisch im Kalender angezeigt
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#fef5ee] transition-colors" data-id="element-598">
                  <div className="flex items-center justify-between mb-2" data-id="element-599">
                    <h3 className="font-medium text-foreground" data-id="element-600">
                      KPI Auto-Berechnung
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-601" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-602">
                    KPIs werden automatisch aus Ihren Kontakt-Aktivitäten
                    berechnet
                  </p>
                </div>

                <Button variant="secondary" className="w-full" onClick={() => alert('Neue Automation erstellen - Feature in Entwicklung')} data-id="element-603">
                  <Zap className="h-4 w-4 mr-2" data-id="element-604" />
                  Neue Automation erstellen
                </Button>
              </CardContent>
            </Card>}
        </div>
      </div>
    </div>;
}